/* Oryan Golf Guided Chatbot v3 (draft prepared 2026-10-15, NOT installed)
   Copy/catalog refresh of v1 only — engine, styles and flows unchanged.
   Changes: Dexter + Eclipse presented as their 8-color collections,
   Battle Golf gaming line named with its 4 colorways, "luxury" removed
   (brand rule), retired "Follow the star" line removed.
   Shipping/returns text verified 2026-10-15 against the live store
   policies (oryangolf.com/policies/shipping-policy and /refund-policy)
   and corrected where v1 drifted (22 business days, photos for damage
   claims, refund timing, cancellation-before-production).
   Single-file embeddable widget. Paste before </body> on Shopify theme,
   or load via <script src=".../oryan-chat-widget.js"></script>.
   No backend, no monthly cost. Intake submits via Shopify /contact. */
(function () {
  'use strict';

  /* ---------- Styles ---------- */
  var CSS = `
  #og-chat-btn{position:fixed;bottom:22px;right:22px;width:60px;height:60px;border-radius:50%;
    background:linear-gradient(135deg,#00e5ff,#7b2ff7);border:none;cursor:pointer;z-index:99998;
    box-shadow:0 4px 24px rgba(0,229,255,.45);display:flex;align-items:center;justify-content:center;
    transition:transform .2s}
  #og-chat-btn:hover{transform:scale(1.08)}
  #og-chat-btn svg{width:30px;height:30px;fill:#fff}
  #og-chat-win{position:fixed;bottom:96px;right:22px;width:370px;max-width:calc(100vw - 32px);
    height:520px;max-height:calc(100vh - 130px);background:#0d1117;border:1px solid #1f6f8b;
    border-radius:16px;z-index:99999;display:none;flex-direction:column;overflow:hidden;
    box-shadow:0 12px 48px rgba(0,0,0,.6);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}
  #og-chat-win.og-open{display:flex}
  #og-chat-head{background:linear-gradient(135deg,#0a2540,#1b1f3b);padding:14px 16px;color:#fff;
    display:flex;align-items:center;gap:10px;border-bottom:1px solid #1f6f8b}
  #og-chat-head .og-dot{width:10px;height:10px;border-radius:50%;background:#00e676;
    box-shadow:0 0 8px #00e676;flex-shrink:0}
  #og-chat-head .og-title{font-weight:700;font-size:15px;flex:1}
  #og-chat-head .og-sub{font-size:11px;color:#8b9bb4;font-weight:400}
  #og-chat-close{background:none;border:none;color:#8b9bb4;font-size:20px;cursor:pointer;line-height:1}
  #og-chat-close:hover{color:#fff}
  #og-chat-body{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px;
    background:#0d1117}
  .og-msg{max-width:82%;padding:10px 14px;border-radius:14px;font-size:14px;line-height:1.45;
    animation:og-in .25s ease-out;word-wrap:break-word}
  @keyframes og-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
  .og-bot{background:#1a2332;color:#e6edf3;border-bottom-left-radius:4px;align-self:flex-start;
    border:1px solid #243447}
  .og-user{background:linear-gradient(135deg,#00b8d4,#7b2ff7);color:#fff;border-bottom-right-radius:4px;
    align-self:flex-end}
  .og-opts{display:flex;flex-wrap:wrap;gap:8px;align-self:flex-start;max-width:100%}
  .og-opt{background:#13202f;border:1px solid #00e5ff;color:#00e5ff;border-radius:20px;
    padding:8px 16px;font-size:13px;cursor:pointer;transition:all .15s;font-weight:600}
  .og-opt:hover{background:#00e5ff;color:#0d1117}
  #og-chat-input{display:flex;gap:8px;padding:12px;border-top:1px solid #1f2d3d;background:#0d1117}
  #og-chat-text{flex:1;background:#1a2332;border:1px solid #2a3a4d;border-radius:20px;color:#fff;
    padding:10px 16px;font-size:14px;outline:none}
  #og-chat-text:focus{border-color:#00e5ff}
  #og-chat-text::placeholder{color:#5a6c7d}
  #og-chat-send{background:linear-gradient(135deg,#00e5ff,#7b2ff7);border:none;border-radius:50%;
    width:40px;height:40px;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center}
  #og-chat-send svg{width:18px;height:18px;fill:#fff}
  #og-chat-send:disabled{opacity:.4;cursor:default}
  .og-typing{align-self:flex-start;background:#1a2332;border:1px solid #243447;border-radius:14px;
    border-bottom-left-radius:4px;padding:12px 16px;display:flex;gap:5px}
  .og-typing span{width:7px;height:7px;border-radius:50%;background:#00e5ff;animation:og-t 1.2s infinite}
  .og-typing span:nth-child(2){animation-delay:.15s}.og-typing span:nth-child(3){animation-delay:.3s}
  @keyframes og-t{0%,60%,100%{opacity:.3;transform:none}30%{opacity:1;transform:translateY(-4px)}}
  `;

  /* ---------- Conversation data ---------- */
  var RUGS = {
    dexter: { name: 'The Dexter Collection', price: '$149.99', desc: 'Our original pattern in eight colors: Bearcat (red/black — named for the Dexter High School Bearcats), Midnight, Voltage, Emerald, Ember, Reign, Rosé, Lagoon and Gilt. A putting mat that doesn\'t look like one.' },
    eclipse: { name: 'The Eclipse Collection', price: '$149.99', desc: 'Our very first design in eight colors: Eclipse (gold — the original), Nebula, Solar, Aurora, Solstice, Umbra, Nova, Glacier and Blood Moon. Metallic-look color on black that shifts with the light.' },
    meridian: { name: 'Meridian', price: '$149.99', desc: 'Clean lines, modern edge. For the minimalist who still wants to drain putts.' },
    belt: { name: "Oryan's Belt", price: '$149.99', desc: 'Star-inspired design from the Oryan World universe — named for the stars of Orion\'s Belt.' },
    gaming: { name: 'Battle Golf Gaming Rugs', price: '$89.99', desc: 'Game-night putting rugs with tic-tac-toe, beer pong and target games printed right on the mat. Four colorways: Mainframe, Nightdrive, Arcade and Onyx.' }
  };

  /* ---------- State ---------- */
  var state = 'welcome';       // current conversation node
  var contactMsg = {};         // talk-to-josh answers
  var body, textInput;

  /* ---------- Helpers ---------- */
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function scrollDown() { body.scrollTop = body.scrollHeight; }
  function botSay(html, cb, delay) {
    var t = el('div', 'og-typing', '<span></span><span></span><span></span>');
    body.appendChild(t); scrollDown();
    setTimeout(function () {
      t.remove();
      var m = el('div', 'og-msg og-bot', html);
      body.appendChild(m); scrollDown();
      if (cb) setTimeout(cb, 350);
    }, delay || 700);
  }
  function userSay(text) {
    body.appendChild(el('div', 'og-msg og-user', escapeHtml(text)));
    scrollDown();
  }
  function showOptions(opts) {
    // opts: [[label, value], ...]
    var wrap = el('div', 'og-opts');
    opts.forEach(function (o) {
      var b = el('button', 'og-opt', escapeHtml(o[0]));
      b.onclick = function () { wrap.remove(); handleChoice(o[1], o[0]); };
      wrap.appendChild(b);
    });
    body.appendChild(wrap); scrollDown();
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Shopify contact submit ---------- */
  function submitToShopify(subject, message, done) {
    // Posts to Shopify's built-in contact form -> emails the store owner.
    var form = new FormData();
    form.append('form_type', 'contact');
    form.append('utf8', '✓');
    form.append('contact[subject]', subject);
    form.append('contact[body]', message);
    fetch('/contact', { method: 'POST', body: form, credentials: 'same-origin' })
      .then(function () { done(true); })
      .catch(function () { done(false); });
  }

  /* ---------- Conversation engine ---------- */
  function handleChoice(value, label) {
    userSay(label);
    setTimeout(function () { route(value); }, 400);
  }

  function route(value) {
    switch (value) {
      case 'shop': showShop(); break;
      case 'rug-dexter': case 'rug-eclipse': case 'rug-meridian': case 'rug-belt': case 'rug-gaming':
        rugDetail(value.replace('rug-', '')); break;
      case 'shipping': shipInfo(); break;
      case 'returns': returnInfo(); break;
      case 'human': startHuman(); break;
      case 'main': mainMenu(); break;
      default: mainMenu();
    }
  }

  function mainMenu(msg) {
    state = 'menu';
    botSay(msg || "What can I help you with?", function () {
      showOptions([
        ['Shop Rugs', 'shop'],
        ['Shipping Info', 'shipping'],
        ['Returns', 'returns'],
        ['Talk to Josh', 'human']
      ]);
    });
  }

  function showShop() {
    state = 'shop';
    botSay("We've got two lines. <b>Designer rugs ($149.99)</b> — two full collections in eight colors each, plus Meridian and Oryan's Belt. A putting mat that doesn't look like one. And <b>Battle Golf gaming rugs ($89.99)</b> — game-night rugs with the games printed right on the mat. Which one do you want to hear about?", function () {
      showOptions([
        ['Dexter Collection', 'rug-dexter'],
        ['Eclipse Collection', 'rug-eclipse'],
        ['Meridian', 'rug-meridian'],
        ["Oryan's Belt", 'rug-belt'],
        ['Battle Golf Gaming', 'rug-gaming'],
        ['Back', 'main']
      ]);
    });
  }

  function rugDetail(key) {
    var r = RUGS[key];
    botSay('<b>' + escapeHtml(r.name) + ' — ' + escapeHtml(r.price) + '</b><br>' + escapeHtml(r.desc), function () {
      showOptions([
        ['More Rugs', 'shop'],
        ['Shipping Info', 'shipping'],
        ['Main Menu', 'main']
      ]);
    });
  }

  function shipInfo() {
    botSay("All rugs are <b>made to order</b> and standard shipping is <b>free</b>.<br><br>Production: 3–7 business days<br>Transit: about 4–15 business days<br><br>Please allow up to 22 business days total from order to door.", function () {
      showOptions([['Returns', 'returns'], ['Main Menu', 'main']]);
    });
  }

  function returnInfo() {
    botSay("<b>30-day returns</b> — request within 30 days of delivery, rug unused and in its original packaging.<br><br>On regular returns you cover return shipping. If anything arrives damaged, defective, or wrong, contact us within 7 days of delivery with photos and we'll cover the authorized return shipping.<br><br>No restocking fees. No exchanges — return and reorder instead. Approved refunds go back to your original payment method within 5 days of us receiving and inspecting the return.<br><br>Need to cancel? Do it before production begins — once production starts, cancellation can't be guaranteed.", function () {
      showOptions([['Shipping Info', 'shipping'], ['Talk to Josh', 'human'], ['Main Menu', 'main']]);
    });
  }

  /* ----- Talk-to-Josh intake ----- */
  function startHuman() {
    state = 'human_name';
    contactMsg = {};
    botSay("No problem — let's get a message to Josh. What's your <b>name</b>?", null, 600);
  }

  function handleText(text) {
    text = text.trim();
    if (!text) return;
    userSay(text);

    if (state === 'human_name') {
      contactMsg.name = text;
      state = 'human_email';
      setTimeout(function () { botSay("And your <b>email</b>?", null, 500); }, 400);
    } else if (state === 'human_email') {
      if (!/^\S+@\S+\.\S+$/.test(text)) {
        setTimeout(function () { botSay("That email doesn't look right — try once more?", null, 500); }, 400);
        return;
      }
      contactMsg.email = text;
      state = 'human_msg';
      setTimeout(function () { botSay("What's your <b>question or message</b> for Josh?", null, 500); }, 400);
    } else if (state === 'human_msg') {
      contactMsg.msg = text;
      state = 'menu';
      setTimeout(function () {
        botSay("Sending…", null, 400);
        submitToShopify(
          'Website Chat — ' + contactMsg.name,
          'Message from the website chatbot:\n\nName: ' + contactMsg.name + '\nEmail: ' + contactMsg.email + '\n\n' + contactMsg.msg + '\n\nReply to: ' + contactMsg.email,
          function (ok) {
            botSay(ok
              ? "Message sent! Josh will get back to you at <b>" + escapeHtml(contactMsg.email) + "</b>."
              : "That didn't go through — try emailing Josh directly.",
              function () { showOptions([['Main Menu', 'main']]); }, 600);
          }
        );
      }, 700);
    } else {
      // Free text outside a flow -> guide back to menu
      setTimeout(function () {
        botSay("I can help with products, shipping, returns — or get a message to Josh. Pick one below:", function () {
          showOptions([
            ['Shop Rugs', 'shop'],
            ['Shipping Info', 'shipping'],
            ['Returns', 'returns'],
            ['Talk to Josh', 'human']
          ]);
        }, 500);
      }, 400);
    }
  }

  /* ---------- Build DOM ---------- */
  function init() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var btn = el('button', '', '');
    btn.id = 'og-chat-btn';
    btn.setAttribute('aria-label', 'Chat with us');
    btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/><path d="M7 9h10v2H7zm0-3h10v2H7z" opacity=".0"/><circle cx="8.5" cy="11" r="1.2"/><circle cx="12" cy="11" r="1.2"/><circle cx="15.5" cy="11" r="1.2"/></svg>';

    var win = el('div', '', '');
    win.id = 'og-chat-win';
    win.innerHTML =
      '<div id="og-chat-head"><div class="og-dot"></div>' +
      '<div class="og-title">Oryan Golf<div class="og-sub">Typically replies instantly</div></div>' +
      '<button id="og-chat-close" aria-label="Close chat">×</button></div>' +
      '<div id="og-chat-body"></div>' +
      '<div id="og-chat-input"><input id="og-chat-text" type="text" placeholder="Type a message…" autocomplete="off" maxlength="500">' +
      '<button id="og-chat-send" aria-label="Send"><svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button></div>';

    document.body.appendChild(btn);
    document.body.appendChild(win);

    body = win.querySelector('#og-chat-body');
    textInput = win.querySelector('#og-chat-text');
    var sendBtn = win.querySelector('#og-chat-send');

    function toggle(force) {
      var open = force !== undefined ? force : !win.classList.contains('og-open');
      win.classList.toggle('og-open', open);
      if (open && !body.children.length) {
        botSay("Hey! Welcome to <b>Oryan Golf</b> — designer putting rugs, veteran-owned and operated. What can I do for you?", function () {
          showOptions([
            ['Shop Rugs', 'shop'],
            ['Shipping Info', 'shipping'],
            ['Returns', 'returns'],
            ['Talk to Josh', 'human']
          ]);
        }, 600);
      }
      if (open) setTimeout(function () { textInput.focus(); }, 300);
    }

    btn.onclick = function () { toggle(); };
    win.querySelector('#og-chat-close').onclick = function () { toggle(false); };

    function send() {
      var v = textInput.value;
      textInput.value = '';
      handleText(v);
    }
    sendBtn.onclick = send;
    textInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') send();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
